import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { useLanguage } from '../utils/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const { t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 50;
      setIsScrolled(scrolled);

      // Calculate scroll progress
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = (window.scrollY / totalHeight) * 100;
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <div 
        className="scroll-progress" 
        style={{ width: `${scrollProgress}%` }}
      />
      <nav className={`navigation ${isScrolled ? 'scrolled' : ''}`}>
        <div className="container nav-container">
          <div className="nav-logo">Ahmed Asakrah</div>
          
          <ul className={`nav-links ${isMobileMenuOpen ? 'open' : ''}`}>
            <li><a href="#home" onClick={() => scrollToSection('home')}>{t('nav.home')}</a></li>
            <li><a href="#about" onClick={() => scrollToSection('about')}>{t('nav.about')}</a></li>
            <li><a href="#experience" onClick={() => scrollToSection('experience')}>{t('nav.experience')}</a></li>
            <li><a href="#education" onClick={() => scrollToSection('education')}>{t('nav.education')}</a></li>
            <li><a href="#skills" onClick={() => scrollToSection('skills')}>{t('nav.skills')}</a></li>
            <li><a href="#certificates" onClick={() => scrollToSection('certificates')}>{t('nav.certificates')}</a></li>
            <li><a href="#projects" onClick={() => scrollToSection('projects')}>{t('nav.projects')}</a></li>
            <li><a href="#contact" onClick={() => scrollToSection('contact')}>{t('nav.contact')}</a></li>
          </ul>

          <div className="nav-actions">
            <LanguageSwitcher />
            <button 
              className="mobile-menu-toggle" 
              onClick={toggleMobileMenu}
              aria-label="Toggle mobile menu"
            >
              {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navigation; 